import React, { useLayoutEffect, useRef, useState } from "react";
import "./styles/TablesSApp.css";
import { BoardProps } from "./Components/types/types";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import TextArea from "./Components/hooks/TextArea";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import { TimerProvider } from "./TimerContext";
import FullscreenToggle from "./FullscreenToggle";

const AppContent: React.FC<BoardProps> = ({
  random,
  rounds,
  type,
  difficulty,
}) => {
  const sceneRef = useRef<HTMLDivElement>(null);
  const [sceneHeight, setSceneHeight] = useState(0);

  // пересчитываем высоту сцены при изменении размеров окна
  useLayoutEffect(() => {
    const scene = sceneRef.current;

    if (!scene) return;

    const resize = () => {
      const height = scene.offsetHeight;
      setSceneHeight((height / window.innerWidth) * 100);
    };

    resize();

    const observer = new ResizeObserver(resize);
    observer.observe(scene);

    return () => observer.disconnect();
  }, []);

  return (
    <div id="tableS-content">
      <div className="tableS-conteiner">
        <div className="tableS-titleGame">
          <div
            className={`tableS-mainsubtitle ${type === 3 ? "tableS-mainsubtitle--type3" : ""}`}
          >
            Таблица с томресек {type}
          </div>
          <FullscreenToggle />
        </div>
        <div
          className={`tableS-game-wrapper ${type !== 3 ? "tableS-default-game" : ""}`}
        >
          <div
            ref={sceneRef}
            className={`tableS-Scene ${type === 3 ? "tableS-type3-Scene" : " "}`}
          >
            <TopBar />
            <Board
              random={random}
              rounds={rounds}
              type={type}
              difficulty={difficulty}
            />
          </div>
          {type !== 3 && <TextArea sceneHeight={sceneHeight} />}
        </div>
        <Helppanel type = {type}/>
      </div>
    </div>
  );
};

const App: React.FC<BoardProps> = (props) => {
  return (
    <GameProvider>
      <TimerProvider>
        <AppContent
          random={props.random}
          rounds={props.rounds}
          type={props.type}
          difficulty={props.difficulty}
        />
      </TimerProvider>
    </GameProvider>
  );
};

export default App;
